const KEY = "authToken";

export const authStorage = {
  async set(token: string): Promise<void> {
    if (!token) return;

    try {
      await OfficeRuntime.storage.setItem(KEY, token);
    } catch {}

    try {
      localStorage.setItem(KEY, token);
    } catch {}
  },

  async get(): Promise<string | undefined> {
    try {
      const officeValue = await OfficeRuntime.storage.getItem(KEY);
      if (typeof officeValue === "string" && officeValue) return officeValue;
    } catch {}

    try {
      const localValue = localStorage.getItem(KEY);
      if (localValue) {
        try {
          await OfficeRuntime.storage.setItem(KEY, localValue);
        } catch {}
        return localValue;
      }
    } catch {}

    return undefined;
  },

  async clear(): Promise<void> {
    try {
      await OfficeRuntime.storage.removeItem(KEY);
    } catch {}

    try {
      localStorage.removeItem(KEY);
      localStorage.removeItem("isAuthenticated"); // legacy cleanup
    } catch {}
  },
};